<ng-container *transloco="let t">
<form #borrowerPickerForm="ngForm" class="form" novalidate id="borrowerPickerForm" name="borrowerPickerForm">
  <select class="form-select form-select-solid" data-control="select2" name="type" [(ngModel)]="value"  (ngModelChange)="borrowerChanged($event)"
    #modelValue="ngModel" [required]="required" [ngClass]="{'is-invalid' : modelValue && modelValue.touched && modelValue.invalid}">
    <option value="">{{ t('common.selectOne') }}</option>
    @for (borrower of borrowers; track borrower.borrowerId) {
      <option [ngValue]="borrower.borrowerId">
        {{borrower.firstName + ' ' + borrower.lastName}}
      </option>
    }
  </select>
  <div class="invalid-feedback">{{ t('wizard.employment.borrowerRequired') }}</div>
</form>
</ng-container>
